import React, { Component } from "react";
import Auth from "../../utils/auth";
import * as queryService from "../../services/query/query-service";
import * as Loader from "../../common/common";
import DropDown from "../../components/form-controls/dropdown";
import { defaultListItem } from "../../common/const";
export default class Query extends Component {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      query: "",
      subject: "",
      validationErrors: {
        subject: "",
        query: "",
      },
      successMsg: "",
      subjectData: "",
    };
    this.saveQuery = this.saveQuery.bind(this);
  }

  onChange(e) {
    let name = e.target.name;

    if (name === "query") {
      this.setState({
        ...this.state,
        [name]: e.target.value.toUpperCase(),
      });
    } else {
      this.setState({
        ...this.state,
        [name]: e.target.value,
      });
    }
  }
  onSubmit(e) {
    e.preventDefault();
    Loader.showLoader();
    let validationErrors = Object.assign({}, this.state.validationErrors);
    let error = false;
    if (!this.state.query) {
      validationErrors.query = "Please enter message";
      error = true;
    } else {
      validationErrors.query = "";
    }
    if (!this.state.subject) {
      validationErrors.subject = "Please enter subject";
      error = true;
    } else {
      validationErrors.subject = "";
    }

    if (error) {
      Loader.hideLoader();
      this.setState({
        ...this.state,
        validationErrors: validationErrors,
      });
      return;
    }

    e.preventDefault();
    this.saveQuery();
  }
  async saveQuery() {
    let data = {
      query: this.state.query,
      subject: this.state.subject,
    };
    let { response, err } = await queryService.saveQuery(data);
    Loader.hideLoader();
    if (err) {
    } else if (response && response.data.err) {
    } else {
      if (response.data.success) {
        this.setState({
          ...this.state,
          validationErrors: {
            subject: "",
            query: "",
          },
          query: "",
          subject: "",
          successMsg: "Your query submitted successfully",
        });
      }
    }
  }
  async componentDidMount() {
    Loader.showLoader();
    let { response, err } = await queryService.getQueryByGroup("Subject");
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      if (response.data) {
        this.setState({
          subjectData: response.data,
        });
      }
    }
  }
  render() {
    let success = "bg-success text-white";

    let objsubjectOptionData = this.state.subjectData;

    return (
      <React.Fragment>
        <div className="app mt-5 align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card-group">
                  <div className="card p-4">
                    <div className="card-body">
                      <form onSubmit={this.onSubmit}>
                        <h3 className="page-title text-info text-center">
                          SUBMIT YOUR QUERY
                        </h3>
                        <hr />
                        <p
                          style={{ textAlign: "center" }}
                          className={this.state.successMsg ? success : ""}
                        >
                          {this.state.successMsg}
                        </p>
                        <DropDown
                          label="Subject"
                          name="subject"
                          required={true}
                          value={this.state.subject || ""}
                          error={this.state.validationErrors.subject}
                          onChange={this.onChange}
                          defaultItem={defaultListItem}
                          list={objsubjectOptionData}
                          valProp="name"
                          textProp="name"
                        />

                        <div className="form-group ">
                          <label htmlFor="query">
                            Message<span className="mandatory">*</span>
                            <h6>
                              <small>(Maximum 1000 characters)</small>
                            </h6>
                          </label>

                          {/* <input type="text" name="query" value={this.state.query} className={this.state.validationErrors.query ? 'is-invalid form-control' : 'form-control'} placeholder="Enter your query" onChange={this.onChange} /> */}
                          <textarea
                            name="query"
                            value={this.state.query}
                            className={
                              this.state.validationErrors.query
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            placeholder="Enter your query"
                            onChange={this.onChange}
                            rows="5"
                            cols="10"
                            maxLength="1000"
                          ></textarea>
                          <span className="error-msg">
                            {this.state.validationErrors.query}
                          </span>
                        </div>
                        <div>
                          <input
                            className="btn btn-primary btn-lg float-right"
                            type="submit"
                            value="Submit"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
